/**
 * Suzy Love — home scroll entrance animations
 */
(function () {
  if (!document.body.classList.contains('template-index')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const main = document.getElementById('MainContent');
  if (!main) return;

  const sections = Array.from(main.querySelectorAll(':scope > .shopify-section'));
  if (!sections.length) return;

  document.body.classList.add('suzylove-motion');

  function markChildren(section) {
    const staggerRoot =
      section.querySelector('.product-list-featured') ||
      section.querySelector('.collection-list') ||
      section.querySelector('[class*="resource-list"]') ||
      section.querySelector('.section-content') ||
      null;

    if (!staggerRoot) return;

    const kids = Array.from(staggerRoot.children).filter((el) => {
      if (!(el instanceof HTMLElement)) return false;
      if (el.hidden) return false;
      return true;
    });

    if (kids.length < 2) return;

    staggerRoot.classList.add('suzylove-reveal-stagger');
    kids.slice(0, 8).forEach((kid) => kid.classList.add('suzylove-reveal-child'));
  }

  sections.forEach((section, index) => {
    section.classList.add('suzylove-reveal');
    if (index === 0) section.classList.add('suzylove-reveal--hero');
    markChildren(section);
  });

  // Hero content (headline + CTA) — animate inner blocks a beat after section
  const hero = sections[0];
  if (hero) {
    const heroContent =
      hero.querySelector('.hero__content') ||
      hero.querySelector('.section-content-wrapper') ||
      hero.querySelector('[class*="content"]');
    if (heroContent instanceof HTMLElement) {
      heroContent.classList.add('suzylove-reveal', 'suzylove-reveal--hero');
      heroContent.style.transitionDelay = '0.12s';
    }
  }

  const reveal = (el) => {
    el.classList.add('is-visible');
    if (el.classList.contains('shopify-section')) {
      el.querySelectorAll('.suzylove-reveal-stagger').forEach((group) => {
        group.classList.add('is-visible');
      });
    }
  };

  if (!('IntersectionObserver' in window)) {
    sections.forEach(reveal);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12,
    }
  );

  // Reveal hero immediately (above the fold)
  requestAnimationFrame(() => {
    reveal(sections[0]);
    const heroInner = sections[0]?.querySelector('.suzylove-reveal--hero:not(.shopify-section)');
    if (heroInner) reveal(heroInner);
  });

  sections.slice(1).forEach((section) => observer.observe(section));

  // Nested stagger groups also observed if they start off-screen inside section
  main.querySelectorAll('.suzylove-reveal-stagger').forEach((group) => {
    const parentSection = group.closest('.shopify-section');
    if (parentSection === sections[0]) {
      // when hero section visible, stagger too
      requestAnimationFrame(() => reveal(group));
      return;
    }
    observer.observe(group);
  });
})();
